const transactionType = {
  GET_TRANS: "GET TRANSACTIONS",
};

export default transactionType;
